import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { SelectFSLightBoxActions } from '../constants/select_fs_light_box/select_fs_light_box_actions';

class SelectFSLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            expanded: false,
            invalid: false,
            invalidMessage: '',
            obj: null,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.SELECT_FS_LIGHTBOX_ACTION) {
            switch (action.type) {
                case SelectFSLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.obj = action.payload;
                        this.__emitChange();
                    }

                    break;

                case SelectFSLightBoxActions.ERROR:
                    if (!state.visible) {
                        state.visible = true;
                        state.invalid = true;
                        state.invalidMessage = action.payload.error;
                        state.obj = null;
                        this.__emitChange();
                    }

                    break;

                case SelectFSLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.obj = null;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const SelectFSLightBoxStore = new SelectFSLightBoxStoreClass(Dispatcher);
export { SelectFSLightBoxStore };
